import { Badge } from '@mui/material';
import { RootState } from '../../redux/store';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useAppSelector } from '../../redux/hooks';
import { useEffect, useState } from 'react';

export function CartBarBadgeIcon({ isSmallFont = false }: { isSmallFont?: boolean }) {
  const shoppingCartItems = useAppSelector((state: RootState) => state.shoppingCartState.items);
  const [servicesCount, setServicesCount] = useState(0);

  useEffect(() => {
    setServicesCount(
      shoppingCartItems.reduce((sum, item) => {
        return sum + item.count;
      }, 0)
    );
  }, [shoppingCartItems]);

  return (
    <Badge
      sx={{
        mr: '10px',
        '& .MuiBadge-badge': {
          backgroundColor: '#f50057',
          color: 'white',
        },
      }}
      badgeContent={servicesCount}
    >
      <ShoppingCartIcon fontSize={isSmallFont ? 'small' : 'medium'} />
    </Badge>
  );
}
